import React, { Component } from "react";

class Tabs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: ""
    };
  }
  onChangeValue = value => {
    this.setState({ value: value });
  };
  add = (groupId, segmentId, value) => {
    this.setState({ value: "" });
    this.props.addPromotion(groupId, segmentId, value);
  };
  render() {
    let tabs = [];
    this.props.tabs.map((item, key) => {
      this.props.compete.customerSegmentData.map(comp => {
        comp.segments.map(segments => {
          if (
            item.groupId === comp.groupId &&
            item.segmentId === segments.segmentId
          ) {
            tabs.push(
              <li
                className="nav-item"
                key={`${item.groupId + `id` + item.segmentId}`}
                onClick={()=>this.props.onTabChange(key)}
              >
                <a
                  data-toggle="tab"
                  className={key === this.props.tabStep ? "nav-link active show" : "nav-link"}
                  href={`#${item.groupId + `id` + item.segmentId}`}
                  aria-controls={`${item.groupId + `id` + item.segmentId}`}
                  aria-selected="true"
                >
                  {comp.groupName + ` - ` + segments.name}
                </a>
              </li>
            );
          }
        });
      });
    });
    let tabsContent = this.props.tabs.map((tabItem, key) => {
      return (
        <div
          id={tabItem.groupId + `id` + tabItem.segmentId}
          className={
            key === this.props.tabStep
              ? "tab-pane fade show active tabContentdiv positioning-tab-content"
              : "tab-pane fade tabContentdiv compete-tab-content positioning-tab-content"
          }
          role="tabpanel"
          key={key}
        >
          <div className="row">
            <div className="col-md-6">
              <div className="row">
                <div
                  className="col-md-4"
                  style={{ textAlign: "center", fontWeight: "bold" }}
                >
                  Offer
                </div>
                <div
                  className="col-md-8"
                  style={{ textAlign: "center", fontWeight: "bold" }}
                >
                  The Whole Product
                </div>
                {/* Core */}
                <div className="col-md-4">Core:</div>
                <div className="col-md-8">
                  <div className="resultsDiv">
                    <ul style={{ listStyle: "none", paddingLeft: "0" }}>
                      {tabItem.product.offer.core.map(core => {
                        return <li>{core}</li>;
                      })}
                    </ul>
                  </div>
                </div>
                {/* Augmented Product: */}
                <div className="col-md-4">Augmented Product:</div>
                <div className="col-md-8">
                  <div className="resultsDiv">
                    <ul style={{ listStyle: "none", paddingLeft: "0" }}>
                      {tabItem.product.offer.augmentProduct.map(
                        augmentProduct => {
                          return <li>{augmentProduct}</li>;
                        }
                      )}
                    </ul>
                  </div>
                </div>

                {/* Services: */}
                <div className="col-md-4">Services:</div>
                <div className="col-md-8">
                  <div className="resultsDiv">
                    <ul style={{ listStyle: "none", paddingLeft: "0" }}>
                      {tabItem.product.offer.services.map(services => {
                        return <li>{services}</li>;
                      })}
                    </ul>
                  </div>
                </div>
                <div className="col-md-4">Information and Consulting:</div>
                <div className="col-md-8">
                  <div className="resultsDiv">
                    <ul style={{ listStyle: "none", paddingLeft: "0" }}>
                      {tabItem.product.offer.intPartnership.map(
                        intPartnership => {
                          return <li>{intPartnership}</li>;
                        }
                      )}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6" style={{marginTop: "23px"}}>
              <div className="row">
                <div className="col-md-2">Price:</div>
                <div className="col-md-9">
                  <div className="resultsDiv">{tabItem.price}</div>
                </div>
                <div className="col-md-2">Place:</div>
                <div className="col-md-9">
                  <div className="resultsDiv">
                    <ul style={{ listStyle: "none", paddingLeft: "0" }}>
                      {tabItem.place.review1.map((item, key) => {
                        return <li key={key}>{item} </li>;
                      })}
                    </ul>
                  </div>
                </div>
                <div className="col-md-2">Promotion:</div>
                <div className="col-md-9">
                  <div className="resultsDiv">
                    <ul style={{ listStyle: "none", paddingLeft: "0" }}>
                      {tabItem.promotion.map(prom => {
                        return <li>{prom.value}</li>;
                      })}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    });
    return (
      <div className="criteria-tabs-content attractiveness-tab-content">
        <ul className="nav nav-tabs benefitsNavTabs" role="tablist" id="myTab">
          {tabs}
        </ul>
        <div className="tab-content benefitsTabcontent" id="myTabContent">
          {tabsContent}
        </div>
      </div>
    );
  }
}

export default Tabs;



// WEBPACK FOOTER //
// ./src/components/ValuePropositionComponent/Result/Tabs/Tabs.jsx